export const CARD_STATES = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
  PAUSED: 'PAUSED'
}

export const MASTERCARD = 'mastercard'
export const VISA = 'visa'
